import React, { useState } from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import LoadingBox from "common/components/LoadingBox";

import loadContent from "core-module/hoc/loadContent";

import IpCountCard from "./AdvancedSettingsIpCountCard.jsx";
import NatOnCard from "./NatOnCard.jsx";
import RegistrationForm from "./AdvancedSettingsRegistrationForm.jsx";

const Settings = props => {
  const [formActive, setFormActive] = useState(false);
  const [registrationInfo, setRegistrationInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const selectEdit = (bpsid, ipaddr, mask, gateway, type) => {
    setRegistrationInfo({
      static: type,
      bpsId: bpsid,
      ipAddress: ipaddr,
      networkMask: mask,
      gateway: gateway
    });
    setFormActive(true);
  };

  const selectCreate = type => {
    setRegistrationInfo({
      static: type === "static" ? true : false,
      bpsId: 0
    });
    setFormActive(true);
  };

  if (isLoading) {
    return <LoadingBox />;
  }

  if (props.getData("nat", "value")) {
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          <NatOnCard />
        </GridItem>
      </GridContainer>
    );
  }

  if (formActive) {
    let autoFillCustomValue = null;
    if (props.additionalConnect.hw != null) {
      autoFillCustomValue = {
        mac_address: props.additionalConnect.hw
      };
    }

    return (
      <RegistrationForm
        pathids={{ ipaddr_registermac: registrationInfo.bpsId }}
        registrationInfo={registrationInfo}
        onCancelRegistration={() => {
          setRegistrationInfo({});
          setFormActive(false);
        }}
        setIsLoading={setIsLoading}
        autoFillCustomValue={autoFillCustomValue}
      />
    );
  }

  return (
    <GridContainer justify="center">
      <GridItem xs={12}>
        <IpCountCard
          selectCreate={selectCreate}
          selectEdit={selectEdit}
          setIsLoading={setIsLoading}
          onCancelRegistration={() => {
            setRegistrationInfo({});
            setFormActive(false);
          }}
        />
      </GridItem>
    </GridContainer>
  );
};

export default loadContent("user.session/isnaton", Settings, state => ({
  hw: state.services.ids.hw
}));
